export function isCookieListEmpty(props) {
    return !props.type;
}
export function wrapElement(el, wrapper) {
    el.parentNode?.insertBefore(wrapper, el);
    wrapper.appendChild(el);
}
